export const words = {
  place: "Lieu",
  yes: "Oui",
  no: "Non",
  new: "Nouveau",
  agb: "CONDITIONS GÉNÉRALES DE VENTE",
  agb_full: "Conditions générales de vente",
  datenschutzerklaerung: "Déclaration de confidentialité",
  status: "Statut",
  company_name: "Nom de l'entreprise",
  next_button: "Continuer",
  device_name: "Nom de l'appareil",
  to_connect: "Relier",
  pin: "NIP",
  time: "Temps",
  first_name: "Prénom",
  last_name: "Nom de famille",
  code: 'Code',
  help: "Aide",
  total_time: "Temps total",
  latitude: "Latitude",
  longitude: "Longitude",
  accuracy: "Précision",
  timestamp: "Horodatage",
  device_id: "ID de l'appareil",
  active: "actif",
  o_clock: "Horloge",
  loading: "Chargement",
  annotation: "Note",
  since: "depuis",
  camera: "Caméra",
  map: "Carte",
  gallery: 'Galerie',
  work: "Travailler",
  employees: "Collaborateurs",
  login: "Inscription",
  login_action: "S'inscrire",
  calendar_week_abbreviation: 'KW',
  calendar: "Calendrier",
  to_call: "Appeler",
  email: "Courrier électronique",
  attachment: "Annexe",
  operational_planning: "Plan d'intervention",
  to_scan: "Numérisation",
  download: "Télécharger",
  export: "Exporter",
  to_document: "Documenter",
  checklist: "Liste de contrôle",
  checklists: "Listes de contrôle",
  password: "Mot de passe",
  confirmation: "Confirmation",
  confirm: "Confirmer",
  confirmation_email: "Courriel de confirmation",
  unknown: "Inconnu",
  unknown_place: "Emplacement inconnu",
  unknown_plan: "Horaire de service non nommé",
  project_no: "N° de projet",
  project_file: "Dossier de projet",
  contact_person: "Personne de contact",
  overtime: "Heures supplémentaires",
  timesheet: "Liste des heures",
  minustime: "Heures négatives",
  back: "Retour",
  undo: "Annuler",
  clockout: "Pointage",
  clocked_out: "estampillé",
  clockin: "Tamponner",
  clocked_in: "estampillé",
  dismiss: "Annuler",
  discard: "Rejeter",
  finish: "Prêt",
  or: "ou",
  copy: "Copier",
  qr_code: "Code QR",
  documentation: "Saisie des temps & documentation",
  attendance: "Terminal pour tablette",
  tiercontent: "Étendue du paquet",
  start_now: "Commencer maintenant",
  skip: "Sauter",
  logout_during_core_time: "Poinçonné pendant les heures creuses",
  absent_during_core_time: "Absent pendant le temps de base",
  distance: "Distance",
  km_reading: "Kilométrage",
  the_start: "Lancement",
  the_end: "Fin",
  license_plate: "Numéro d'immatriculation",
  details: "Détails",
  hide: "masquer",
  cost: "Coûts",
  file: "Fichier",
  address_book: "Carnet d'adresses",
  template_plural: "Modèles",
  signature: "Signature",
  main_project: "Projet principal",
  main_projects: "Principaux projets",
  sub_projects: "Sous-projets",
  scan_to_login_header: "Code QR inscription",
  description: "Description",
  project_location: "Lieu du projet",
  phone_number: "Numéro d'appel",
  project_info: "Informations sur le projet",
  number_short: "No.",
  sketch: "Sketch",
  video: "Vidéo",
  delete: "Supprimer",
  send: "Envoyer",
  sending: "Envoyer...",
  save: "Enregistrer",
  granted: "approuvé",
  pending: "demande",
  denied: "refusé",
  customer: "Client",
  mobile_number: "Numéro de téléphone",
  ok: 'Ok',
  day: "Jour",
  tomorrow: "Matin",
  days: "jours | jour | jours",
  holidays: "Jours fériés",
  vacation_days: "Jours de congé",
  vacation_hours: "Heures de vacances",
  request: "Demande",
  accept: "Accepter",
  withdraw: "Retirer",
  hour_account: "Compte d'heures",
  period: "Période",
  to: "jusqu'à",
  date: "Rendez-vous",
  number: "Nombre",
  message: "Message",
  change: "changer",
  changed: "Changé",
  changed_fields: "Changement de domaine",
  type: 'Art',
  hour: "Heure",
  hours: "Heures",
  hours_abbreviation: 'Std.',
  hours_with_amount: "{amount} Heures",
  end: "terminer",
  end_date: "Date de fin",
  start_date: "Date de lancement",
  absence: "Absence",
  month: "Mois",
  week: "Semaine",
  transcript: "Transcription",
  time_left: "restant",
  transcript_tasks: "Tâches",
  add_task: "Nouveau",
  /** Differentiation in some languages (e.g. English) */
  from: "de",
  of: "de",
  of_hours: "de {hours} heures",
  of_hours_abbreviation: "de {hours} heures",
  /**************/

  used: "utilise",
  update: "Actualiser",
  today: "aujourd'hui",
  correction: "Correction",
  work_time: "Temps de travail",
  break: 'Pause',
  loading_time: "Temps de chargement",
  driving_time: "Temps de trajet",
  business_trip: "Sortie de service",
  project: "Projet",
  special_one: "Spécial1",
  special_two: "Spécial2",
  clock: "Horloge",
  search: "Recherche",
  operation: "Activité",
  day_protocol: "Protocole journalier",
  continue: "continuer",
  total_duration: "Temps total",
  duration: "Durée",
  hello: "Bonjour",
  close: "fermer",
  comment: "Commentaire",
  small: "petit",
  medium: "moyen",
  large: "grand",
  sharpie: "Stylo",
  line: "Ligne",
  arrow: "Flèche",
  rectangle: "Rectangle",
  ellipse: 'Ellipse',
  text: "Texte",
  language_settings: "Paramètres linguistiques",
  clock_reminder: "Rappel de timbre",
  individually: "Individu",
  from_o_clock: "de",
  to_o_clock: "jusqu'à",
  eraser: "Gomme",
  edit: "Modifier",
  legal_notes: "Mentions légales",
  notes: "Notes",
  note: "Note",
  imprint: "Mentions légales",
  open_source_licenses: "Conditions de licence open source",
  author: "Auteur",
  license_type: "Type de licence",
  version: 'Version',
  substitute: "Représentation",
  not_rated: "Non évalué",
  weekly_working_hours: "Heures de travail hebdomadaires",
  show_less: "Afficher moins",
  office_center: "Centre de bureaux",
  admin_view: "Gestion NFC",
  register: "Registre",
  shifts: {
    shift_attachments: "Accessoires (couche)",
    shift_plan_attachments: "Attaches (plan de quarts)",
    shift_plan: "Horaire des équipes",
    shift: "Couche"
  },
  absences: {
    sick: "Maladie (maintien du salaire)",
    vacation: "Vacances",
    workshop: "Séminaire/formation",
    special_vacation: "Congé spécial",
    school: "École",
    working_time_account: "Compte de temps de travail",
    holiday: "Jour férié",
    other: "Autres",
    driving_time: "Temps de trajet",
    parental_leave: "Congé parental",
    excused_absent: "Absent excusé (payé)",
    not_excused_absent: "Jour d'absence non excusé",
    sick_industrial_accident: "Maladie Accident du travail (ONIAM)",
    short_time_work: "Chômage partiel (Kug)",
    maternity_pay: "Salaire de protection de la maternité/interdiction d'emploi",
    sick_child: "Soigner un enfant malade avec des indemnités (journalières) de maladie",
    sick_child_no_payment: "Soigner un enfant malade sans indemnités (journalières) de maladie",
    vacation_no_payment: "Congé non payé",
    sick_before_short_time_work: "Indemnité de maladie/maladie avant l'allocation",
    weather_related_failure: "Panne due aux intempéries",
    sick_short_time_work: "Maladie pendant une cuba",
    sick_no_payment: "Maladie (sans maintien du salaire)",
    company_vacation: "Fermeture annuelle",
    meals_14_euro: "Petite indemnité de repas",
    meals_28_euro: "Grand forfait de repas"
  },
  image_editor: {
    font_size: "Taille de la police",
    stroke_width: "Épaisseur de la ligne",
    stroke_color: "Couleur de la ligne",
    text_color: "Couleur de la police",
    rotate_left: "Tourner vers la gauche",
    rotate_right: "Tourner vers la droite",
    flip_horizontal: "Refléter horizontalement",
    flip_vertical: "Miroir vertical"
  },
  travel_log: {
    method_of_transportation: "Moyens de transport",
    company_car: "Voiture de fonction",
    private_car: "Voiture privée",
    rental_car: "Location de voiture",
    taxi: 'Taxi',
    public_transportation: "Transports publics",
    airplane: "Avion",
    train: "Rail (transport public longue distance)",
    other: "Autres",
    km_reading_start: "Kilométrage Début",
    km_reading_end: "Fin du kilométrage",
    net_expenses: "Frais de déplacement (nets)",
    tax: "Taxe sur le chiffre d'affaires"
  },
  read_in: "Lecture",
  currency: "Monnaie",
  reason: "Justification",
  label: "Étiquette",
  monday: "Lundi",
  tuesday: "Mardi",
  wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",
  saturday: "Samedi",
  sunday: "Dimanche",
  break_alarm: "Casser le réveil",
  clockin_reminder: "Rappel de pointage",
  clockout_reminder: "Rappel de désabonnement"
};